<template>
  <div class="tw-px-12 tw-py-6 tw-text-gray-900">
    <div class="tw-flex tw-justify-between tw-items-center">
      <h1 class="tw-font-medium tw-text-2xl">Invoice</h1>
      <img class="tw-h-16" :src="imgSrc" />
    </div>
    <div class="tw-flex tw-mt-4">
      <div class="tw-font-medium">
        <div>Invoice Number</div>
        <div>Date of Issue</div>
        <div>Date due</div>
      </div>
      <div class="tw-ml-6 tw-text-gray-700">
        <div>{{ invoice.invoiceNumber }}</div>
        <div>{{ formatDate(invoice.dateOfIssue) }}</div>
        <div>{{ formatDate(invoice.dateDue) }}</div>
      </div>
    </div>
    <div class="tw-flex tw-mt-6">
      <div class="tw-w-1/2">
        <div class="tw-font-medium">{{ invoice.businessName }}</div>
        <div class="tw-text-gray-700">{{ invoice.line1 }}</div>
        <div class="tw-text-gray-700" v-if="invoice.line2">{{ invoice.line2 }}</div>
        <div class="tw-text-gray-700">{{ invoice.city }}, {{ invoice.state }} {{ invoice.zipCode }}</div>
        <div class="tw-text-gray-700"><base-phone-number-field :value="invoice.phoneNumber" /></div>
        <div class="tw-mt-4">
          <div class="tw-font-medium">Prescriber</div>
          <div class="tw-text-gray-700">{{ invoice.prescriberName }}</div>
        </div>
      </div>
      <div class="tw-w-1/2">
        <div class="tw-font-medium">Bill To</div>
        <div class="tw-text-gray-700">{{ invoice.billToName }}</div>
        <div class="tw-text-gray-700">{{ invoice.billToEmail }}</div>
      </div>
    </div>
    <div class="tw-text-xl tw-font-medium tw-mt-6 tw-flex"><MoneyFormat :value="invoice.amountDueInCents" subunits-value />&nbsp;due {{ formatDate(invoice.dateDue) }}</div>
    <base-table :fields="fields" :items="invoice.invoiceItems" class="tw-mt-2">
      <template #amount="{ item: { amountInCents }}">
        <MoneyFormat :value="amountInCents" subunits-value />
      </template>
      <template #unitPrice="{ item: { unitPriceInCents }}">
        <MoneyFormat :value="unitPriceInCents" subunits-value />
      </template>
    </base-table>
    <div class="tw-mt-6 tw-flex tw-justify-end">
      <div class="tw-w-1/2">
        <div class="tw-flex tw-justify-between tw-border-t tw-py-2">
          <div>Subtotal</div>
          <div><MoneyFormat :value="invoice.subtotalInCents" subunits-value /></div>
        </div>
        <div class="tw-flex tw-justify-between tw-border-t tw-py-2">
          <div>Total</div>
          <div><MoneyFormat :value="invoice.totalInCents" subunits-value /></div>
        </div>
        <!-- <div class="tw-flex tw-justify-between tw-border-t tw-py-2 tw-font-medium">
          <div>Amount Due</div>
          <div><MoneyFormat :value="invoice.amountDueInCents" subunits-value /></div>
        </div> -->
      </div>
    </div>
    <div id="complete" v-if="isComplete"></div>
    <div class="tw-mt-6">
      <h2 class="tw-text-lg tw-font-medium">Important Information:</h2>
      <p class="tw-text-gray-700 tw-text-sm tw-mt-2">
        Rx Harmony works together with board-licensed medical providers and PCAB-accredited compounding pharmacy partners to offer a single, flat-rate monthly payment for
        personalized wellness programs that include:
      </p>
      <ul class="tw-list-disc tw-pl-2 tw-text-gray-700 tw-text-sm">
        <li>*Custom Compounded Medication(s)</li>
        <li>*Medical Supplies-Syringe / Needle</li>
        <li>*Medical Supplies - Alcohol Swab</li>
        <li>*Medical Supplies - Sharp Container</li>
        <li>*Priority Overnight Shipping</li>
        <li>*Access to VIP Patient Success Coordinator</li>
        <li>*Medication Management by Your Healthcare Provider</li>
        <li>*Program Education and Support Materials</li>
        <li>*Patient Reported Outcome Surveys for Improved Outcomes</li>
      </ul>
      <p class="tw-text-gray-700 tw-mt-4 tw-text-sm">
        <strong>Itemized receipts are unavailable as we work with multiple healthcare partners and shipping suppliers to provide this comprehensive service.</strong>
      </p>
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: {
    MoneyFormat,
  },
  props: {
    businessId: String,
    userId: String,
    chargeId: String,
  },
  data() {
    return {
      isComplete: false,
      fields: [
        { key: "description", title: "Description" },
        { key: "quantity", title: "Quantity", align: "right", thClass: "tw-text-right" },
        { key: "unitPrice", title: "Unit Price", align: "right", thClass: "tw-text-right" },
        { key: "amount", title: "Amount", align: "right", thClass: "tw-text-right" },
      ],
      invoice: {},
    };
  },
  computed: {
    ...mapGetters("avatar", ["getVersion"]),
    version() {
      return this.getVersion(this.id);
    },
    imgSrc() {
      return `/api/uploads/businesses/${this.businessId}/avatar/base-image?v=${this.version}`;
    },
  },
  created() {
    this.getInvoice();
  },
  methods: {
    async getInvoice() {
      const response = await this.$axios.get(`/pdf/invoice/businesses/${this.businessId}/users/${this.userId}/charge/${this.chargeId}`);
      this.invoice = response.data;
      await this.$nextTick();
      this.isComplete = true;
    },
    formatDate(date) {
      return moment(date).format("MMMM Do, YYYY");
    },
  },
};
</script>
